import { useState } from "react";
import { FaLock, FaBan } from "react-icons/fa";
import PrivacySettings from "../components/account/PrivacySettings";
import BlockingSettings from "../components/account/BlockingSettings";

const AccountCenter = () => {
  const [activeTab, setActiveTab] = useState("privacy");

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Two Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
          {/* Left Side - Tabs */}
          <div className="lg:col-span-3">
            <div className="bg-white rounded-lg border shadow-sm">
              <div className="p-3 border-b">
                <h2 className="text-base font-semibold text-gray-900 font-roboto-flex">
                  Myst Account Center
                </h2>
              </div>
              <div className="p-2">
                <button
                  onClick={() => setActiveTab("privacy")}
                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left transition-colors font-roboto-flex text-sm ${
                    activeTab === "privacy"
                      ? "bg-primary-50 text-primary-700 border border-primary-200"
                      : "text-gray-700 hover:bg-gray-50"
                  }`}
                >
                  <FaLock className="text-base" />
                  <span className="font-medium">Privacy</span>
                </button>
                <button
                  onClick={() => setActiveTab("blocking")}
                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-left transition-colors font-roboto-flex text-sm mt-2 ${
                    activeTab === "blocking"
                      ? "bg-primary-50 text-primary-700 border border-primary-200"
                      : "text-gray-700 hover:bg-gray-50"
                  }`}
                >
                  <FaBan className="text-base" />
                  <span className="font-medium">Blocking</span>
                </button>
              </div>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="lg:col-span-9">
            <div className="bg-white rounded-lg border shadow-sm">
              {activeTab === "privacy" && <PrivacySettings />}
              {activeTab === "blocking" && <BlockingSettings />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountCenter;

